import type { ComputedRef } from 'vue'

export interface Paging {
  page: ComputedRef<number>
  pageSize: Ref<number>
  offset: ComputedRef<number>
}

export const usePaging = (pageSize: number): Paging => {
  const route = useRoute()
  const page = computed(() => {
    if (!route.query.page) return 1
    const page = parseInt(route.query.page as string)
    if (isNaN(page)) return 1
    return page
  })
  const offset = computed(() => (page.value - 1) * pageSize)
  return {
    page: page,
    pageSize: ref(pageSize),
    offset: offset,
  }
}
